import { FormArray, FormGroup } from '@angular/forms';

import type { RepeatableComputeContext, RepeatableSubField } from '../../../interfaces/input.interface';
import type { RepeatableLogger } from './repeatable-group.types';
import { RepeatableValueUtils } from './repeatable-value.utils';

export class RepeatableComputeEngine {
    public constructor(private readonly logger: RepeatableLogger) {}

    public recomputeAll(source: string, rowsArray: FormArray<FormGroup>, subFields: RepeatableSubField[], model: FormGroup | null): void {
        const rowsForCompute = RepeatableValueUtils.getRowsSnapshotAsStrings(rowsArray, subFields);

        for (let rowIndex = 0; rowIndex < rowsArray.length; rowIndex++) {
            const rowGroup = rowsArray.at(rowIndex);

            for (const subField of subFields) {
                if (typeof subField.computeValue !== 'function') {
                    continue;
                }

                const context: RepeatableComputeContext = {
                    rowIndex,
                    rows: rowsForCompute,
                    model: model ?? new FormGroup({}),
                };

                let computedValue: string;

                try {
                    computedValue = subField.computeValue(context);
                } catch (error: unknown) {
                    this.logger.warn('computeValue() threw. Skipping patch.', {
                        source,
                        rowIndex,
                        key: subField.key,
                        error,
                    });
                    continue;
                }

                const control = rowGroup.get(subField.key);
                const row = rowsForCompute[rowIndex];

                if (!control || !row) {
                    continue;
                }

                if (!RepeatableValueUtils.areEqualLoose(control.value, computedValue)) {
                    control.patchValue(computedValue, { emitEvent: false });
                    row[subField.key] = String(computedValue);
                }
            }
        }
    }
}
